@if (currentUrl !== '/dashboard' && currentUrl !== '/admin/dashboard') {
  <div class="mb-6 bg-[var(--mat-color-light-table)] px-4 py-4 rounded h-[54px] flex items-center">
    <div class="row w-full">
      <div class="col-sm-8">
        <div class="d-flex align-items-center overflow-hidden">
          <ul class="flex justify-center gap-4 items-center">
            <a class="text-[var(--mat-color-primary)]! cursor-pointer hover:scale-[1.02] text-[14px] duration-100" [routerLink]="currentUrl.includes('/admin') ? '/admin' : '/'">
              {{ 'home' | translate }}
            </a>
            <i-tabler name="chevron-right" class="icon-14 text-gray-500" />
            @for (url of pageInfo?.['urls']; track url.url; let index = $index,last = $last) {
              @if (!last) {
                @if (url.type === 'icon') {
                  <i-tabler [name]="url.title" class="icon-18" />
                } @else {
                  @if (url.disabled) {
                    <span class="text-[14px] text-gray-600 dark:text-gray-300">{{ url.title | translate }}</span>
                  } @else {
                    <a class="text-[var(--mat-color-primary)]! cursor-pointer hover:scale-[1.02] text-[14px] duration-100" [routerLink]="url.url">
                      {{ url.title | translate }}
                    </a>
                  }
                  <i-tabler name="chevron-right" class="icon-14 text-gray-500" />
                }
              } @else {
                @if (url.type === 'icon') {
                  <i-tabler [name]="url.title" class="icon-18" />
                } @else {
                  <li class="text-[14px] text-gray-600 dark:text-gray-300">{{ url.title | translate }}</li>
                }
              }
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}
